import React, { useEffect, useMemo, useState } from 'react';
import { Col } from 'react-bootstrap';
import CustomContainer from '../../components/CustomContainer';
import BigCalendar from '../../components/lakeview/calendar/BigCalendar';
import { useFetchObject } from '../../components/hook/useFetchObject';
import Filters from '../../components/filter/Filters';
import { MockActions } from '../../../client/MockActions';
import renderUtils from '../../helpers/renderUtils';
import { stayStatusMapping } from '../../components/lakeview/StayStatusIcon';

const CalendarPage = () => {
  const [selectedFilters, setSelectedFilters] = useState({});
  const { data: houses, ready: housesReady } = useFetchObject('house', []);
  const { data: reservations, ready: reservationsReady } = useFetchObject('reservation', []);
  const { data: blockedDays, ready: blockedDaysReady } = useFetchObject('blocked-days', []);
  const { data: bookingBlockedDays, ready: bookingBlockedDaysReady } = useFetchObject(
    () => 'booking-blocked-days',
    [],
  );

  const filtersConfig = useMemo(() => {
    if (!housesReady) return [];
    return [
      {
        key: 'houses',
        label: 'Domki',
        type: 'dropdown', // <- lub "modal"
        options: houses.map((h) => ({ label: h.name, value: h.id }))
      },
      {
        key: 'stayStatuses',
        label: 'Status',
        type: 'dropdown', // <- lub "modal"
        options: Object.keys(stayStatusMapping).map((s) => ({
          label: stayStatusMapping[s].label,
          value: s
        }))
      }
    ];
  }, [housesReady, houses]);

  useEffect(() => {
    if (housesReady && houses.length > 0 && !selectedFilters.houses) {
      setSelectedFilters({
        houses: houses.map((h) => h.id),
        stayStatuses: Object.keys(stayStatusMapping)
      });
    }
  }, [housesReady, houses]);

  const filteredReservations = useMemo(
    () => reservations?.filter((res) =>
      (selectedFilters.houses || []).includes(res.houses[0]?.id)
      &&
      (selectedFilters.stayStatuses || []).includes(res.stayStatus)
    ),
    [reservations, selectedFilters]
  );

  const filteredBlockedDays = useMemo(
    () =>
      [
        ...(blockedDays || []),
        ...((bookingBlockedDays || []).map((bd) => ({
          ...bd,
          bookingBlock: true,
        }))),
      ].filter((bd) => (selectedFilters.houses || []).includes(bd.house?.id)),
    [blockedDays, bookingBlockedDays, selectedFilters]
  );

  if (!housesReady || !reservationsReady || !blockedDaysReady || !bookingBlockedDaysReady) return <></>;

  return (
    <CustomContainer
      title="Kalendarz"

    >
      <>

        <Filters
          config={filtersConfig}
          value={selectedFilters}
          onChange={setSelectedFilters}
        />
        <Col className={'mt-4 mb-5'}>
          <BigCalendar height="100vh" reservations={filteredReservations} blocked={filteredBlockedDays} />
        </Col>
      </>


    </CustomContainer>
  );
};

export default CalendarPage;
